import { IconProps } from './index';

const NewConversation: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M10.5361 2.5V4.16667L2.2028 4.16667L2.2028 15.3208L3.67197 14.1667L15.5361 14.1667V8.33333L17.2028 8.33333L17.2028 15C17.2028 15.221 17.115 15.433 16.9587 15.5893C16.8024 15.7455 16.5905 15.8333 16.3695 15.8333L4.24863 15.8333L0.536133 18.75L0.536133 3.33333C0.536133 3.11232 0.62393 2.90036 0.78021 2.74408C0.936491 2.5878 1.14845 2.5 1.36947 2.5L10.5361 2.5ZM14.7028 2.5V0L16.3695 0V2.5L18.8695 2.5V4.16667H16.3695V6.66667H14.7028L14.7028 4.16667L12.2028 4.16667V2.5L14.7028 2.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default NewConversation;
